import { PageWrapper } from "@/components/ui/PageWrapper";
import { EditPolicy } from "@/pages/supplier/settings/refund/cancellation-policy/[policyId]/+EditPolicy";
import { useSelectiveCancellationPolicyQuery } from "@/pages/supplier/settings/refund/cancellation-policy/[policyId]/queries-cancellation-policies";
import { seo } from "@/utils/seo";
import { Box, Flex, QueryHandler, Text } from "@givenwell/components";
import { colors } from "@givenwell/theme";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/supplier/$supplierId/settings/refunds/")({
  component: Page,
  head: () => ({
    meta: seo({ title: "Refund Settings" }),
  }),
});

function Page() {
  const { supplierId } = Route.useParams();

  const query2 = useSelectiveCancellationPolicyQuery(supplierId);
  return (
    <PageWrapper title="Refund Settings" maxWidth={1400}>
      <Flex css={{ gap: 16 }}>
        <Box css={{ flex: 2, spaceY: 16 }}>
          {/* <DataTable>
            <DataTableCard>
              <Heading css={{ weight: 500 }}>Cancellation Policy</Heading>
              <Text css={{ fontScale: "xs", color: colors.text2 }}>
                Create and manage custom cancellation policies. These can be defined in each listing.
              </Text>
            </DataTableCard>
          </DataTable> */}
          <QueryHandler query={query2} success={({ data: policy }) => <EditPolicy policy={policy} />} />
        </Box>
      </Flex>
      <Text
        css={{
          mt: 8,
          fontScale: "sm",
          color: colors.text2,
        }}
      >
        Refund settings do not apply to EAP listings.
      </Text>
    </PageWrapper>
  );
}
